import { mapActions } from 'vuex';
import disqus from '@/components/disqus/disqus.vue';

export default {
  components: {
    disqus,
  },
  data() {
    return {
      disqusReady: false,
      disqusAuth: '',
    };
  },
  computed: {
    disqusId() {
      return this.$route.name;
    },
    disqusTitle() {
      return document.title;
    },
    disqusUrl() {
      return window.location.href;
    },
  },
  methods: {
    ...mapActions('user', ['getDisqusUserAuth']),
    setupDisqus() {
      this.getDisqusUserAuth()
        .then((data) => {
          this.disqusReady = true;
          this.disqusAuth = data;
        });
    },
  },
};




// WEBPACK FOOTER //
// ./src/mixins/disqus.js